import { AutoComplete, Input, Tooltip, Breadcrumb, message } from "antd";
// import { t } from "i18next";
import { ActiveIcon, InactiveIcon, AddIcon } from "../../../asset/icons";
import { EditIcon, DeleteIcon, DetailIcon, SearchIcon, AscRed, DescGrey, CloseIconSearch } from "../../../asset";
import style from "./AdditionalProofs.module.css";
import CustomTable from "../../../component/table/CustomTable";
import PrimaryButton from "../../../component/button/PrimaryButton";
import { CustomerListColumn } from "../../../constant/tableConstant";
import DeleteConfirmationModal from "../../../component/modal/DeleteConfirmationModal";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constant/routeConstant";
import axios from "axios";
import _, { transform } from "lodash";
import ModalDelete from "../../../component/modal/ModalDelete";
import Delete from "../../../component/modal/ModalDelete";
import CustomPaging from "../../../component/pagination/pagination";
import { GROLOG_URL } from "../../../constant/apiConstant";
import Breadcumbs from '../../../component/page-components/breadcumbs/breadcumbs';
import { useDispatch, useSelector } from "react-redux";
import { onChanged } from "../../../util/Util";
const AdditionalProofsList = (props) => {
  const { token, client_id, grolog_account_id, userId } = useSelector((state) => state.auth);
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`; 
  
  const { t } = useTranslation();
  const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] =
    useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [listData, setListData] = useState([]);
  const navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);
  const [searchRecommendation, setSearchRecommedation] = useState()
  const [listRecommendation, setListRecommendation] = useState([])
  const [sorting, setSorting] = useState("asc");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState([]);
  const [filter, setFilter] =useState()
  const [loading, setLoading] = useState(false)
  const [isFilter, setIsfilter] = useState(false);
  const dispatch = useDispatch()

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    
    // const api = `http://app.sbp:9038/v1/grolog`;
    const api = GROLOG_URL
    const url = api + endpoint;
    const method = "GET";
    const headers = { "Authorization": tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const fetchData = async (data, sort, pages) => {
    setLoading(true)
    let id = 1;
    let res = await doGet(
      `/additional-proofs?page=${pages ? pages :page}&limit=${limit}&order=id ${sort? sort :sorting}${filter ? "&filter=additional_name lk " + filter : data ? "&filter=additional_name lk "+ data : ""}&${param}`,
      token
    );
    let init = await doGet(
      `/additional-proofs/initiate?page=${pages ? pages :page}&limit=${limit}&order=id ${sort? sort :sorting}${filter ? "&filter=additional_name lk " + filter : data ? "&filter=additional_name lk "+data:""}&${param}`,
      token
    );
    setListData(res?.data?.payload?.data);
    setInitiate(init?.data?.payload?.data);
    if(init?.data?.payload.data){
      setInitiate(init?.data?.payload.data);
    }else{}
    setListData(res?.data?.payload?.data);
    setLoading(false)
  };

  useEffect(() => {
    fetchData();
    onChanged(dispatch, false)
  }, [page,limit,filter]);

  const handleEdit = (id) => {
    navigate(ROUTES.ADDITIONAL_PROOFS.EDIT, { state: id });
  };

  const handleDetail = (id) => {
    navigate(ROUTES.ADDITIONAL_PROOFS.DETAIL, { state: id });
  };

  const setModal = async (data, condition) => {
    await setData(data);
    await setShowDelete(true);
  };

  const dataSource = listData
    ? listData.map((result) => ({
        name: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.additional_name}
          </span>
        ),

        desc: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.description}
          </span>
        ),
        toMenu: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.to_menu}
          </span>
        ),
        action: (
          <div className="flex gap-[26px]">
            <Tooltip title={t("USER:EDIT_TOOLTIP")} color="#CF0000">
              <button onClick={() => handleEdit(result?.id)}>
                <img src={EditIcon} alt="edit" />
              </button>
            </Tooltip>
            <Tooltip title={t("Delete")} color="#CF0000">
              <button onClick={() => setModal(result)}>
                <img src={DeleteIcon} alt="del" />
              </button>
            </Tooltip>

            <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
              <button
                // onClick={() => handleDelete(result?.id, result?.updated_at)}
                onClick={() => handleDetail(result?.id)}
              >
                <img src={DetailIcon} alt="det" />
              </button>
            </Tooltip>
          </div>
        ),
      }))
    : null;

    const doSort = async (sort) => {
      setSorting(sort);
    
      if (sort) {
      setSorting(sort);
        // fetchData();
        
      fetchData(data, sort);
        // this.setState({ loading: true });
        // await this.setState(
        //   {
        //     orderby: `${code+" "+sort}`,
        //     pageProductivitySalesman:1,
        //   }
        // )
      }
    };

  const ListColumn = [
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
        <div style={{ width: "60%" }}>
          <span className="font-roboto text-lg text-[#222222] font-medium">
            {t("Additional Name")}
          </span>
        </div>
        <div style={{ width: "3%", marginLeft: "2px", marginTop: "3px" }}>
          <div className={style.SortArea}>
          <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "asc" ? AscRed : DescGrey}
                  alt="asc"
                  className={sorting === "asc" ? "w-full cursor-pointer":"rotate-180 w-full cursor-pointer"}
                  onClick={() => {
                    doSort("asc");
                  }}
                  // disabled={sorting==="asc"}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "asc" ? DescGrey : AscRed}
                  alt="desc"
                  className={sorting === "asc" ? "w-full cursor-pointer":"rotate-180 w-full cursor-pointer"}
                  onClick={() => {
                    doSort("desc");
                  }}
                  
                  // disabled={sorting==="desc"}
                />
              </Tooltip>
          </div>
        </div>
      </div>
      ),
      dataIndex: "name",
      key: "name",
      // sorter: {
      //   compare: (a, b) => a.name.localeCompare(b.name),
      // },
      render: (name) => <span>{name}</span>,
    },

    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Additional Description")}
        </span>
      ),
      dataIndex: "desc",
      key: "desc",
      render: (desc) => <span>{desc}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Additional to menu")}
        </span>
      ),
      dataIndex: "toMenu",
      key: "toMenu",
      render: (toMenu) => <span>{toMenu}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("USER:ACTION_FIELD")}
        </span>
      ),
      dataIndex: "action",
      key: "action",
      render: (action) => action,
    },
  ];
  const handlePagination = (a,b)=>{
    if (a && b) {
      setPage(a)
      setLimit(b)
    } else {
     
    }
  };

  const fetchRecommendation = async (
    page,
    limit,
    filters,
    mapping_principal_id
  ) => {
    if (filters.length >= 1) {
    let res = await doGet(`/additional-proofs/search?page=1&limit=10&filter=additional_name lk ${filters}`, token);
    setListRecommendation(res?.data?.payload?.data);

    }
  };

  const onSearchRecommendation = async (value) => {
    setIsfilter(true)
    setSearchRecommedation(value)
    if (value) {
      setSearchRecommedation(value)
      await fetchRecommendation(1,10,value)
    } else {
    }
  };

  const onSelectRecommendation =(data) => {
    setPage(1)
    setFilter(data)
    fetchData(data,sorting, 1)
    setIsfilter(false)
  };

  const onClearRecommendation = (e) => {
    setIsfilter(false);
    setFilter(null);
    setSearchRecommedation("");
    setListRecommendation([]);

    fetchData("",sorting, 1);

  };

  const options =
      listRecommendation &&
      listRecommendation.map((item) => ({
        value: item.value,
        label: item.value,
      }));

  return (
    <>
      <Delete
        data={data.updated_at}
        id={data.id}
        delete={showDelete}
        title={data?.additional_name}
        url={"additional-proofs"}
        action={() => setShowDelete(false)}
        route={ROUTES.ADDITIONAL_PROOFS.LIST}
        refresh={()=>fetchData()}
        token={token}
        param={param}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">

        <Breadcumbs
          jmlLevel={3}
          menuLevel1={`Setup`}
          menuLevel2={`Profile Configuration`}
          menuLevel3={`Additional Proofs`}
        />

        <h1 className="font-sans-bold mt-[-15px] text-2xl" id="title">
          {t("Additional Proofs")}
        </h1>

        <div
          className={
            style.headerContainer + " flex justify-between items-center"
          }
        >
         <AutoComplete
                 options={options}
                 value={searchRecommendation}
                 onChange={(value) => onSearchRecommendation(value)}
                 onSelect={(value) => onSelectRecommendation(value)}
               >
              <Input
                placeholder={t("Search Additional Name")}
                className="w-[350px] h-[47px]"
                height={47}
                width={350}
                suffix={<img 
                  src={filter? CloseIconSearch : SearchIcon} 
                  alt="search" 
                  onClick={filter? () => onClearRecommendation() : null}
                />}
                
                // options={options}
                value={searchRecommendation}
                // onChange={(value) => onSearchRecommendation(value)}
              />
            </AutoComplete>
          <Link to={ROUTES.ADDITIONAL_PROOFS.ADD}>
            <PrimaryButton
              text={t("Add Additional Proofs")}
              prefixIcon={<AddIcon />}
            />
          </Link>
        </div>

        {
  !loading ?
        <div className={style.tableContainer}>
          <CustomTable columns={ListColumn} data={dataSource} />
          <div className={style.containerPagination + " mt-[-45px]"}>
            <CustomPaging
              idLimit="ddlrowsperpagemustselllist"
              idPagination="btnpaginationmustselllist"
              size="small"
              current={page}
              defaultCurrent={page}
              pageSize={limit}
              total={initiate && initiate?.count_data}
              pageSizeOptions={initiate && initiate?.valid_limit}
              onShowSizeChange={() => handlePagination()}
              handlePaging={(a,b) => handlePagination(a,b)}
              title={t("COMMON:ROW_PAGE")}
            />
          </div>
        </div>
        : "...loading"}
      </div>
    </>
  );
};

export default AdditionalProofsList;
